import { useEffect, useState, useMemo } from "react";
import useAuthStore from "../states/authStore";
import { NavBar, PageHeader, PageHeaderProvider, AppSwitcher } from "@iq/models";
import { TbClipboard, TbLayoutDashboard, TbTimeline } from "react-icons/tb";
import { GoHome } from "react-icons/go";
import AppUserMenu from "../components/AppUserMenu";
import HeaderClockAction from "../components/HeaderClockAction";
import KanbanPage from "./Pages/Kanban";
import ProjectsPage from "./Pages/Projects"
import TimelinePage from "./Pages/Timeline";
import CRMLogo from "../assets/icons/CRM_logo.svg";
import TicketsLogo from "../assets/icons/Tickets_logo.svg";
import AdminLogo from "../assets/icons/Admin_logo.svg";
const pmNavItems = [
    { id: "kanban", label: "Kanban", icon: <TbLayoutDashboard size={24} /> },
    {id: "projects", label: "Projects", icon: <TbClipboard size={24}/>},
    {id: "timeline", label: "Timeline", icon: <TbTimeline size={24}/>}
];

const PM_PAGE_HEADER_TITLES = {
	Kanban: "Kanban",
    Projects: "Projects",
    Timeline: "Timeline"
};


function PM_tool_Main() {
    const appLinks = useMemo(() => ([
        { label: "CRM", image: CRMLogo, href: "/contacts", variant: "crm" },
        { label: "Tickets", image: TicketsLogo, href: "/IT", variant: "tickets" },
        { label: "Admin", image: AdminLogo, href: "/admin", variant: "admin" },
        { label: "Projects", image: AdminLogo, href: "/projects", variant: "projects" },
        { label: "Payment", image: AdminLogo, href: "/payment", variant: "payment" },
    ]), []);

    const [activePage, setActivePage] = useState("Kanban");
    const profile = useAuthStore((state) => state.profile);
    const profileName = profile?.name ?? "User";
    const profileId = profile?.id ?? null;
    const [selectedProject, setSelectedProject] = useState(null)
    const [pageHeader, setPageHeader] = useState({
        title: PM_PAGE_HEADER_TITLES.Kanban,
        back: false,
        onBack: null,
        children: null,
    });

    useEffect(() => {
        setPageHeader((prev) => {
            if (prev.back || prev.children) {
                return prev;
            }

            const nextTitle = PM_PAGE_HEADER_TITLES[activePage] || PM_PAGE_HEADER_TITLES.Kanban;
            if (prev.title === nextTitle) {
                return prev;
            }

            return {
                title: nextTitle,
                back: false,
                onBack: null,
                children: null,
            };
        });
    }, [activePage]);

    function renderPage() {
        switch (activePage) {
            case "kanban":
            case "Kanban":
                return <KanbanPage setPageHeader={setPageHeader} selectedProject={selectedProject} setSelectedProject={setSelectedProject} />;
            case "projects":
            case "Projects":
                return <ProjectsPage setPageHeader={setPageHeader} selectedProject={selectedProject} setSelectedProject={setSelectedProject}/>;
            case "timeline":
            case "Timeline":
                return <TimelinePage setPageHeader={setPageHeader} selectedProject={selectedProject} setSelectedProject={setSelectedProject}/>
            default:
                return <KanbanPage setPageHeader={setPageHeader} selectedProject={selectedProject} setSelectedProject={setSelectedProject} />;
        }
    }

    return (
        <div className="crm-layout app">
            <div className="nav-section">
                <NavBar
                    activePage={activePage}
                    navItems={pmNavItems}
                    onPageChange={setActivePage}
                    footerAction={{
                        label: "Home",
                        icon: <GoHome size={24} />,
                        onClick: () => {
                            window.location.href = "/";
                        },
                    }}
                />
            </div>
            <PageHeaderProvider userMenu={(
                <>
                    <HeaderClockAction />
                    <AppSwitcher apps={appLinks} activeLabel="Home" />
                    <AppUserMenu name={profileName} id={profileId} />
                </>
            )}
            >
                <PageHeader title={pageHeader.title} back={pageHeader.back} onBack={pageHeader.onBack}>
                    {pageHeader.children}
                </PageHeader>
                {renderPage()}
            </PageHeaderProvider>
        </div>
    );
}

export default PM_tool_Main;